/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate")

package js.features.userAmazonCatalogue

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.promise
import kotlin.js.Promise
import kotlinx.serialization.json.Json
import features.userAmazonCatalogue.UserAmazonCatalogueApi
import features.userAmazonCatalogue.models.UserRewardsModel
import features.userAmazonCatalogue.serializeUserAmazonCatalogueState



/**
 * Get a list of rewards available to this user including the amazon catalogue. [Api] class
 */
@OptIn(DelicateCoroutinesApi::class)
@ExperimentalJsExport
@JsExport
@JsName("UserAmazonCatalogueApi")
class UserAmazonCatalogueApiJs {

    /**
     * Get a list of rewards available to this user including the amazon catalogue.
     */
    fun getUserAmazonCatalogue(
        overrideHeaders: String?, 
        pageNumber: Int,
        perPage: Int,
        keywords: String?,
        filters: String?
    ): Promise<String?>  {
        return GlobalScope.promise {

        val decodedOverrideHeaders = if (overrideHeaders == null) {
                null
        } else {
            try {
                Json.decodeFromString<Map<String, String>>(overrideHeaders)
            } catch (e: Exception) {
                null
                }
            }

            val result = UserAmazonCatalogueApi().getUserAmazonCatalogue(
            overrideHeaders = decodedOverrideHeaders,
                        pageNumber = pageNumber,
            perPage = perPage,
            keywords = keywords,
            filters = filters
        ).toJsonResult<UserRewardsModel>()
        
            return@promise when (result) {
                is SerializedResult.Success -> result.data
                is SerializedResult.UnauthorizedError -> result.error
                is SerializedResult.UnknownError -> result.error
                else -> null
            }
        }
    }

    

    

    fun observeUserAmazonCatalogueState(
        onData: (String) -> Unit,
        onStreamError: (String) -> Unit,
    ) {
        UserAmazonCatalogueApi().userAmazonCatalogueState.serializeUserAmazonCatalogueState().observe { result ->
            when (result) {
                is SerializedResult.Idle -> onData(result.state)
                is SerializedResult.Loading -> onData(result.state)
                is SerializedResult.Success -> onData(result.data)
                is SerializedResult.UnauthorizedError -> onData(result.error)
                is SerializedResult.UnknownError -> onData(result.error)
                else -> onStreamError("unknown error in stream")
            }
        }
    }
}
